import { Controller } from "@hotwired/stimulus"
import Swal from 'sweetalert2'

export default class extends Controller {
    static values = {
        url: String,
        charityName: String
    }

    async open(event) {
        event.preventDefault()

        const { value: confirmed } = await Swal.fire({
            title: 'Run Background Check?',
            text: `Verify ${this.charityNameValue} against CRA and public records.`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Run Check',
            confirmButtonColor: '#0284c7' // Tailwind sky-600
        })

        if (confirmed) {
            this.runCheck()
        }
    }

    runCheck() {
        let secondsElapsed = 0;
        let timerInterval;

        Swal.fire({
            title: 'Verifying Charity...',
            // We add a span with an ID to target for the timer
            html: `
        <div class="mb-4 text-slate-600">Consulting CRA records and digital footprint...</div>
        <div class="text-sm text-slate-400 font-mono font-medium bg-slate-50 py-1 px-3 rounded-full inline-block" id="swal-timer">
          Time elapsed: 0s
        </div>
      `,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();

                // Grab our timer span
                const timerElement = document.getElementById('swal-timer');

                // Start ticking
                timerInterval = setInterval(() => {
                    secondsElapsed++;
                    const minutes = Math.floor(secondsElapsed / 60);
                    const seconds = secondsElapsed % 60;

                    const timeText = minutes > 0 ? `${minutes}m ${seconds}s` : `${seconds}s`;

                    if (timerElement) {
                        timerElement.innerText = `Time elapsed: ${timeText}`;
                    }
                }, 1000);
            },
            willClose: () => {
                // Clean up the interval when the modal closes
                clearInterval(timerInterval);
            }
        })

        fetch(this.urlValue, {
            method: 'POST',
            headers: {
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
                'Accept': 'text/vnd.turbo-stream.html'
            }
        })
    }
}